import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import { Button, Form, Input } from 'antd'

const ResetPass = (props) => {
  const {
    onSubmit,
    onSubmitFailed,
    isSubmit,
  } = props
  const [form] = Form.useForm()

  return (
    <div
      className="form-container d-flex align-items-center justify-content-center"
      style={{
        // backgroundImage: 'url(/assets/bg_dplk.svg)',
        height: '100vh',
        // backgroundSize: 'cover',
        backgroundColor: '#fff',
      }}
    >
      <Form
        name="resetPass"
        className="form-reset-password px-3 pt-4 pb-2 card-login"
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        onFinishFailed={onSubmitFailed}
      >
        <h5 className="mb-4" style={{ color: '#384A76' }}>Reset Password</h5>
        <Row>
          <Col lg={10} className="mx-auto">
            <Form.Item
              name="password"
              className="text-left"
              validateTrigger="onBlur"
              rules={[
                { required: true, message: '*Please input your password!\n' },
                { pattern: /^.{8,}$/, message: '*Please enter at least 8 characters\n' },
                { pattern: /(?=.*[A-Z])(?=.*\d)/, message: '*Password must contain at least one uppercase and number\n' },
                {
                  validator: (rule, value) => {
                    if (value && value.includes(' ')) return Promise.reject('Password contain space')

                    return Promise.resolve()
                  },
                },
              ]}
            >
              <Input.Password placeholder="New Password" />
            </Form.Item>

            <Form.Item
              name="confirm_password"
              className="text-left"
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve()
                    }
                    return Promise.reject(new Error('The Password you entered does not match!'))
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm Password" />
            </Form.Item>

            <Form.Item className="pt-3 btn-primary-wrapper">
              <Button type="primary" className="w-100" size="large" loading={isSubmit} htmlType="submit">Submit</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

ResetPass.propTypes = {
  onSubmit: PropTypes.func,
  onSubmitFailed: PropTypes.func,
  isSubmit: PropTypes.bool,
}

export default ResetPass
